import React from 'react'

const StatsSection = () => {
  return (
    <section id="stats" className="stats section light-background">

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="row gy-4">

          <div className="col-lg-3 col-md-6">
            <div className="stats-item">
              <i className="bi bi-emoji-smile"></i>
              <p><strong>Clientes contentos</strong> <br></br><span>Nos enfocamos en la satisfacci&oacute;n de nuestros clientes</span></p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-item">
              <i className="bi bi-journal-richtext"></i>
              <p><strong>Proyectos personalizados</strong> <span>Tu idea es nuestra prioridad</span></p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-item">
              <i className="bi bi-headset"></i>
              <p><strong>Comunicacion efectiva</strong> <span>Mantenemos el contacto con el cliente</span></p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-item">
              <i className="bi bi-people"></i>
              <p><strong>Trabajo en equipo</strong> <span>Trabajamos de manera colaborativa</span></p>
            </div>
          </div>

        </div>

      </div>

    </section>
  )
}

export default StatsSection